export default "__VITE_ASSET__D8C_onFp__"